module.exports = __webpack_public_path__ + "static/furniture-live-help-section-b2a15097f233bcf0ea432e5ca456a7ea.png";